/*
 *+------------------------------------------------------------------------+
 *| Licensed Materials - Property of IBM
 *| IBM Cognos Products: BI Cloud (C)
 *| (C) Copyright IBM Corp. 2017, 2018
 *|
 *| US Government Users Restricted Rights - Use, duplication or disclosure
 *| restricted by GSA ADP Schedule Contract with IBM Corp.
 *+------------------------------------------------------------------------+
 */
// This file is used to create the require layers. Only the entry points are necessary
define([
	'./LayoutBaseView',
	'./Tab',
	'./GenericPage',
	'./SinglePage'
], function() {

});